<template>
  <div :class="cls_name" v-if="navs && navs.length > 0">
    <div
      :class="{'nav-item':true,'choose':idx === choose}"
      v-for="(item,idx) in navs"
      @click="click_item(item,idx)"
    >{{item.title}}</div>
    
  </div>
</template>
<script>
import { openLink } from "../../tools/mgtv/link";
import click_handler from "../../tools/mgtv/click";
export default {
  name: "NavBar",
  props: {
     parent_name: {
      type: String,
      default: ""
    },
    navs: {
      type: Array,
      default: () => {
        return [
          {
            title: "标题1",
            handler: () => {
              console.log("标题1");
              //回调中
            }
          },
          {
            title: "标题2",
            handler: () => {
              console.log("标题2");
            }
          },
          {
            title: "标题3",
            handler: () => {
              console.log("标题3");
            }
          },
          {
            title: "标题4",
            handler: () => {
              console.log("标题4");
            }
            
          }
        ];
      }
    },
    choose: {
      //目前选中第几个
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {};
  },
  methods: {
    click_item(item, idx) {
      click_handler(`${this.parent_name}-导航条-${item.title}`, () => {
        if (idx === this.choose) {
          return;
        }
        setTimeout(() => {
          if (item.handler) {
            item.handler();
          }
        }, 50);
      });
    }
  },
  mounted() {},
  computed: {
    cls_name() {
      if (this.navs.length > 4) {
        return "cls_navbar_tab cls_navbar_tab_scroll";
      } else {
        return "cls_navbar_tab";
      }
    }
  }
};
</script>


<style lang="stylus" scoped>
 @import "../../share/mixins.styl"
 .cls_navbar_tab
    position relative
    width 7.5rem
    display flex
    height .6rem
    overflow-y hidden
    padding-left .1rem
    .nav-item
        padding 0 .1rem
        text-align center
        flex-shrink  0
        font-size .26rem
        height .6rem
        line-height @height
        position relative
        background #F2F1F1
        margin-right .1rem
        color #444444
        border-radius:4px;


    .choose
      background:linear-gradient(90deg,rgba(254,221,157,1) 0%,rgba(255,197,98,1) 100%) !important
      color white !important
    
  .cls_navbar_tab_scroll
      overflow-x scroll
      -webkit-overflow-scrolling touch
    


        
</style>
